import { useTranslation } from 'react-i18next';

import { ErrorHint } from '$features/monitoring/components/error-hint';

export function DeviceNotConfiguredForHistoryCharts() {
  const { t } = useTranslation();
  return (
    <ErrorHint>
      <ErrorHint.IconHint name="charts" />
      <ErrorHint.Title>
        {t('monitoringDetail.historyChartsDetail.deviceNotConfigured')}
      </ErrorHint.Title>
    </ErrorHint>
  );
}
